import axios from "@/plugins/axios";

let url = "/api/v1/honja/billboards";

export default {
    get({ code }) {
        return axios.get(`${url}/${code}`).then((result) => result.data);
    },
};
